import React from 'react';
import { Route } from 'react-router-dom';
import HeaderBack from '../../../../containers/Headers/components/HeaderBack/HeaderBack';
import { SCREENS } from '../../../../../constants/screens';
import Headers from '../../../../containers/Headers/Headers';
import { Table } from '../../../../components/Table/Table';
import ScreenTabsNavigation from '../../../../containers/ScreenTabsNavigation/ScreenTabsNavigation';
import AreaSales from './containers/AreaSales/AreaSales';
import BranchSales from './containers/BranchSales/BranchSales';

const SalesLocation = () => {
  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderBack title="sales_location" path={SCREENS.REPORTS()} />
      </Headers>
      <div className="d-flex flex-column flex-grow-1 pt-6">
        <Table>
          <>
            <ScreenTabsNavigation
              options={[
                { path: SCREENS.AREA_SALES(), title: 'area_sales' },
                { path: SCREENS.BRANCH_SALES(), title: 'branch_sales' },
              ]}
            />
            <Route path={SCREENS.AREA_SALES()} component={AreaSales} />
            <Route path={SCREENS.BRANCH_SALES()} component={BranchSales} />
          </>
        </Table>
      </div>
    </div>
  );
};

export default SalesLocation;
